var src = {};
export {
  src as __exports
};
//# sourceMappingURL=index2.js.map
